(function ($) {
  "use strict";

  /*
   * =========================================================
   * DOM READY
   * =========================================================
   * Do not wait for window.load.
   * The DOM and theme UI can initialize as soon as the HTML
   * is ready instead of waiting for all images/resources.
   */
  $(function () {

    /*
     * ---------------------------------------------------------
     * MEGA MENU / SUBMENU CLASS INITIALIZATION
     * ---------------------------------------------------------
     * These classes were previously added on window.load,
     * which could delay the correct mega-menu structure.
     */
    $('.megamenu-li').parent('.container').parent('ul').addClass('mega-menu');

    $('.banner-wrap').parent('.container').parent('ul').addClass('bottom-banner');

    $('.menu-banner').parent('.container').parent('ul').addClass('banner-menu');

    $('.submenu-li').parent('.container').parent('ul').addClass('sub-menu');

    $('.submenu-li').parent('ul').addClass('sub-menu');

    $('.megamenu-li').parent('ul').addClass('mega-menu');

    $('.bannermenu-li').parent('ul').addClass('banner-menu');


    /*
     * ---------------------------------------------------------
     * PRELOADER
     * ---------------------------------------------------------
     * Do NOT wait for window.load.
     *
     * The old code used:
     * $('.slow-window').fadeOut('slow');
     *
     * This made the user wait for the entire window load event.
     */
    var $slowWindow = $('.slow-window');

if ($slowWindow.length) {
  $slowWindow
    .stop(true, true)
    .css({
      opacity: 0,
      visibility: 'hidden',
      pointerEvents: 'none'
    });

  setTimeout(function () {
    $slowWindow.remove();
  }, 150);
}


    /*
     * ---------------------------------------------------------
     * NEWSLETTER POPUP
     * ---------------------------------------------------------
     */
    var popup = localStorage.getItem('popup_value');

    if (popup !== '1') {
      var $newsletterModal = $('#news-letter-modal');

      if ($newsletterModal.length && typeof bootstrap !== 'undefined') {
        try {
          var newsletterModal = bootstrap.Modal.getOrCreateInstance(
            $newsletterModal[0]
          );

          newsletterModal.show();
        } catch (e) {
          // Fallback for older Bootstrap/jQuery modal implementation
          if (typeof $newsletterModal.modal === 'function') {
            $newsletterModal.modal('show');
          }
        }
      }
    }

    $('#popup-close').on('click', function () {
      localStorage.setItem('popup_value', '1');
    });


    /*
     * ---------------------------------------------------------
     * MOBILE MENU
     * ---------------------------------------------------------
     */
    $('button.navbar-toggle').on('click', function () {
      $('.main-menu-area').addClass('active');
      $('.mm-fullscreen-bg').addClass('active');
      $('body').addClass('hidden');
    });

    $('.close-box').on('click', function () {
      $('.main-menu-area').removeClass('active');
      $('.mm-fullscreen-bg').removeClass('active');
      $('body').removeClass('hidden');
    });


    /*
     * ---------------------------------------------------------
     * MINI CART
     * ---------------------------------------------------------
     */
    $('.shopping-cart a.cart-count').on('click', function (e) {
      e.preventDefault();

      $('.mini-cart').addClass('show');
      $('.mm-fullscreen-bg').addClass('active');
      $('body').addClass('hidden');
    });

    $('.shopping-cart-close i').on('click', function () {
      $('.mini-cart').removeClass('show');
      $('.mm-fullscreen-bg').removeClass('active');
      $('body').removeClass('hidden');
    });


    /*
     * AJAX CART
     */
    $('.ajax-spin-cart').on('click', function () {
      window.setTimeout(function () {
        $('.mini-cart').addClass('show');
        $('.mm-fullscreen-bg').addClass('active');
        $('body').addClass('hidden');
      }, 1000);
    });


    /*
     * ---------------------------------------------------------
     * FILTER SIDEBAR
     * ---------------------------------------------------------
     */
    $('button.filter-button').on('click', function () {
      $('.filter-sidebar').addClass('active');
      $('.mm-fullscreen-bg').addClass('active');
    });

    $('button.close-filter-sidebar').on('click', function () {
      $('.filter-sidebar').removeClass('active');
      $('.mm-fullscreen-bg').removeClass('active');
    });


    /*
     * ---------------------------------------------------------
     * FULLSCREEN OVERLAY
     * ---------------------------------------------------------
     */
    $('.mm-fullscreen-bg').on('click', function () {
      $('.mini-cart').removeClass('show');
      $('.main-menu-area').removeClass('active');
      $('.mm-fullscreen-bg').removeClass('active');
      $('.filter-sidebar').removeClass('active');
      $('body').removeClass('hidden');
    });


    /*
     * ---------------------------------------------------------
     * BOOTSTRAP TOOLTIPS
     * ---------------------------------------------------------
     * Initialize only if tooltip elements actually exist.
     */
    if (
      typeof bootstrap !== 'undefined' &&
      document.querySelector('[data-bs-toggle="tooltip"]')
    ) {
      document
        .querySelectorAll('[data-bs-toggle="tooltip"]')
        .forEach(function (tooltipTriggerEl) {
          try {
            bootstrap.Tooltip.getOrCreateInstance(tooltipTriggerEl);
          } catch (e) {
            // Ignore tooltip initialization errors
          }
        });
    }


    /*
     * ---------------------------------------------------------
     * MAGNIFIC POPUP
     * ---------------------------------------------------------
     * Initialize only when required elements exist.
     */
    var $popupElements = $('.play-button, .popup-vimeo, .popup-gmaps');

    if (
      $popupElements.length &&
      typeof $popupElements.magnificPopup === 'function'
    ) {
      $popupElements.magnificPopup({
        tClose: 'Close (Esc)',
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
      });
    }


    /*
     * ---------------------------------------------------------
     * BACK TO TOP
     * ---------------------------------------------------------
     */
    $('#top').on('click', function (e) {
      e.preventDefault();

      $('html, body').stop(true, true).animate(
        {
          scrollTop: 0
        },
        0
      );

      return false;
    });


    /*
     * ---------------------------------------------------------
     * CHECKBOX / AGREEMENT
     * ---------------------------------------------------------
     * IMPORTANT:
     * This was previously inside the scroll event.
     * That meant a new click handler was created on every scroll.
     *
     * Now it is registered only once.
     */
    $('label.box-area').on('click', function () {
      if ($('.cust-checkbox').is(':checked')) {
        $('.agree').removeClass('disabled');
      } else {
        $('.agree').addClass('disabled');
      }
    });

  });


  /*
   * =========================================================
   * SCROLL HANDLER
   * =========================================================
   *
   * Only scroll-related operations remain here.
   *
   * requestAnimationFrame prevents excessive DOM updates
   * during very fast scrolling.
   */
  var scrollTicking = false;

  $(window).on('scroll', function () {

    if (!scrollTicking) {

      window.requestAnimationFrame(function () {

        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        /*
         * Back to top button
         */
        if (scrollTop > 1000) {
          $('#top').stop(true, true).fadeIn();
        } else {
          $('#top').stop(true, true).fadeOut();
        }


        /*
         * Sticky header
         */
        var $stickyHeader = $('.header-area');

        if ($stickyHeader.length) {
          if (scrollTop >= 150) {
            $stickyHeader.addClass('is-sticky');
          } else {
            $stickyHeader.removeClass('is-sticky');
          }
        }


        scrollTicking = false;
      });

      scrollTicking = true;
    }

  });

})(jQuery);